import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
import SuspanseLoader from "./SuspanseLoader";

const Analytics = lazy(() => import("./pages/ecommerce/Analytics"));
const Dashboard = lazy(() => import("./pages/ecommerce/Dashboard"));
const Demo = lazy(() => import("./pages/ecommerce/Demo"));
const DynamicPricing = lazy(() => import("./pages/ecommerce/DynamicPricing"));
const Invoices = lazy(() => import("./pages/ecommerce/Invoices"));
const MarketAnalysis = lazy(() => import("./pages/ecommerce/MarketAnalysis"));
const PaymentFailure = lazy(() => import("./pages/ecommerce/PaymentFailure"));
const PaymentSuccess = lazy(() => import("./pages/ecommerce/PaymentSuccess"));
const PricingReview = lazy(() => import("./pages/ecommerce/PricingReview"));
const Settings = lazy(() => import("./pages/ecommerce/Settings"));
const Subscription = lazy(() => import("./pages/ecommerce/Subscription"));
const Support = lazy(() => import("./pages/ecommerce/Support"));
const SystemPerformance = lazy(
  () => import("./pages/ecommerce/SystemPerformance"),
);
const TripManagement = lazy(() => import("./pages/ecommerce/TripManagement"));

export const ecommerceRoutesConfig = [
  {
    index: true,
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <DynamicPricing />
      </Suspense>
    ),
  },
  {
    path: "dashboard",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <DynamicPricing />
      </Suspense>
    ),
  },
  {
    path: "demo",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Demo />
      </Suspense>
    ),
  },
  {
    path: "trips",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <TripManagement />
      </Suspense>
    ),
  },
  {
    path: "analytics",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Analytics />
      </Suspense>
    ),
  },
  {
    path: "customers",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <MarketAnalysis />
      </Suspense>
    ),
  },
  {
    path: "conversion",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <PricingReview />
      </Suspense>
    ),
  },
  {
    path: "performance",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <SystemPerformance />
      </Suspense>
    ),
  },
  {
    path: "settings",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Settings />
      </Suspense>
    ),
  },
  {
    path: "support",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Support />
      </Suspense>
    ),
  },
  {
    path: "subscription",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Subscription />
      </Suspense>
    ),
  },
  {
    path: "subscription-enterprise",
    element: <Navigate to="/subscription" replace />,
  },
  {
    path: "invoices",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Invoices />
      </Suspense>
    ),
  },
  {
    path: "reporting",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <Dashboard />
      </Suspense>
    ),
  },
  {
    path: "payment/success",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <PaymentSuccess />
      </Suspense>
    ),
  },
  {
    path: "payment/failure",
    element: (
      <Suspense fallback={<SuspanseLoader />}>
        <PaymentFailure />
      </Suspense>
    ),
  },
];
